import { useCallback, useRef } from 'react';
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';

export function useIdempotencyKey() {
  const keyRef = useRef<string>(uuidv4());

  const get = useCallback(() => keyRef.current, []);

  const getFor = useCallback((id: string) => uuidv5(id, keyRef.current), []);

  const rotate = useCallback(() => {
    keyRef.current = uuidv4();
    return keyRef.current;
  }, []);

  return { get, getFor, rotate };
}
